import styled from "styled-components";
import Button from "./Base/Button";

const Wrapper = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  text-align: center;
  background-color: rgb(58, 58, 60);
  padding: 3%;
  color: white;
  width: 300px;
  border-radius: 10px;
  z-index: 10;

  .message {
    text-align: left;
  }

  .buttonWrapper {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    width: 200px;
  }

  @media (max-width: 480px) {
    width: inherit;
    border-radius: 0px;
  }
`;

const AcceptButton = styled(Button)`
  margin-top: 5%;
  width: 100%;
  display: block;
`;

const ConfirmationModal = (props) => {
  const cookieConsentAcceptClick = () => {
    localStorage.setItem("cookieConsent", true);
    props.buttonClick();
  };

  return (
    <Wrapper>
      <div className="message">
        We use cookies to improve and customize your experience on our site. If
        you accept cookies, we’ll also use them to show you personalized ads
        when you visit other sites.
      </div>
      <AcceptButton primary onClick={cookieConsentAcceptClick}>
        Got it
      </AcceptButton>
    </Wrapper>
  );
};

export default ConfirmationModal;
